// M19 T15: asks our server for a Mapbox prediction. The server checks the company switch, the daily cap and the Breaker Panel D8 door.
export async function predictDrive(client, body, fetchImpl = globalThis.fetch) {
    const { data } = await client.auth.getSession();
    const response = await fetchImpl('/api/events/mapbox-predict', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${data?.session?.access_token || ''}` },
        body: JSON.stringify(body),
    });
    const answer = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(answer.error || 'Mapbox could not answer right now. The chart number still works.');
    return answer;
}
